<template>
  <div>
    <div class="input-group" id="input-group-tagsinput">
      <history v-if="history"></history>
      <input class="input-group-btn form-control" id="input-search" type="text" value=""  :placeholder="placeholder" data-role="tagsinput" v-model="query" autocomplete="off"/>
      <div class="input-group-btn" v-if="submitButton">
        <vue-ladda type="submit" :loading="submitButton.loading" class="btn btn-info" style="padding: 7px 28px" :data-style="submitButton.dataStyle" @click="submitSearch"><i class="fa fa-2x fa-search"></i></vue-ladda>
      </div>
    </div>
    <typeahead ref="typeahead" v-model="queryWiki" :appendToBody="inModal !== true" target="#input-group-tagsinput > div.bootstrap-tagsinput > input[type=text]"
               class="inputSearchTypeahead" :async-function="getSearchWiki"
               :forceSelect="true" :forceClear="true" @input="typeaheadSelected" :debounce="0" ></typeahead>
    <div class="text-left" style="margin-top: 5px" v-if="helpKeywords === true">
      <span style="font-style: italic;font-size: 12px">Separate groups of keywords by Return, e.g. image sensor ↩︎ efficiency ↩︎</span>
    </div>
  </div>
</template>

<style>
@media (max-width: 768px) {
  #input-group-tagsinput {
    width: 100%;
  }
}

#input-group-tagsinput .bootstrap-tagsinput .tag {
  padding: 5px 15px;
  color: #6a6c6f;
  border-radius: 4px;
}
#input-group-tagsinput .bootstrap-tagsinput .tag:hover {
  color: #6a6c6f;
}
#input-group-tagsinput .bootstrap-tagsinput{
  /*display: table-cell;*/
  overflow: auto;
  max-height: 45px;
  width: 100%;
  min-height: 45px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding: 3px 6px;
}
#input-group-tagsinput input{
  /*width: 100%;*/
  vertical-align: -webkit-baseline-middle;
  vertical-align: middle;
  padding: 2px 6px;
}
.bootstrap-tagsinput .tag{
  color: inherit;}

.bootstrap-tagsinput {
  border: 2px solid #3498db !important;
}

</style>
<style lang="css" scoped>

#input-search {
  height: 41px;
}

#input-search:focus{
  border-right-color: #3498db!important;

}

#input-search::-webkit-input-placeholder {
  font-weight: bold;
}
#input-search::-moz-placeholder {
  font-weight: bold;
}
#input-search::-ms-input-placeholder {
  font-weight: bold;
}

@media (max-width: 767px) {

  #search-box #dropdownTypeDocument{
    margin-top: 15px;
  }
}

</style>
<script>
import 'bootstrap-tagsinput/dist/bootstrap-tagsinput.css'
import VueLadda from 'vue-ladda'
import Tagsinput from '@adactive/bootstrap-tagsinput'
import History from './History'

export default {
  components: {
    History,
    VueLadda,
    Tagsinput
  },
  name: 'Simple',
  props: {
    value: {},
    submitButton: {},
    placeholder: {},
    launchSearch: {},
    history: {
      default: false
    },
    helpKeywords: {
      default: true
    },
    inModal: {
      default: false
    }
  },
  watch: {
    value: function (value) {
      this.query = value
      this.queryToTags()
    }
  },
  data () {
    return {
      query: '',
      urlWiki: 'https://en.wikipedia.org/w/api.php',
      queryWiki: '',
      typeahead: false
    }
  },
  methods: {
    getQuery: function () {
      return this.query
    },
    submitSearch: function (e) {
      if (e !== null) {
        e.preventDefault()
      }
      this.$emit('input', this.query)
      this.launchSearch(e)
    },
    getSearchWiki: function (query, done) {
      let queryTmp = query.match(/"[\w\s]+"|\w+/gm)
      let queryToSearch = ''
      if (query.length > 3 && queryTmp !== null && queryTmp !== '') {
        queryToSearch = query
        $.ajax({
          dataType: 'json',
          url: this.urlWiki + '?origin=*&action=opensearch&search=' + queryToSearch.trim() + '&limit=5&namespace=0&format=json&callback=?',
          cache: true
        }).then((response) => {
          let resp = response[1].indexOf(queryToSearch) !== -1 ? response[1] : [queryToSearch, ...response[1]]
          done(resp)
        }).catch((error) => {

        })
      }
    },
    queryToTags: function () {
      $('#input-search').tagsinput('removeAll')
      if (this.query !== null && this.query.length) {
        let query = this.query.split(',')
        query.forEach((tag) => {
          $('#input-search').tagsinput('add', tag)
        })
        this.parseLogicWord()
      }
    },
    parseLogicWord: function () {
      $('.tag').map(function (key, tag) {
        tag = $(tag)
        let text = $(tag).text().trim()
        if (text === 'AND' || text === 'OR' || text === 'NOT') {
          tag.removeClass('btn-outline btn btn-default')
          tag.addClass('logic-word')
        }
      })
    },
    resizeTagsinpt: function () {
      let tagsinput = $('#input-group-tagsinput input').first()
      if ($('.tag').length === 1) {
        tagsinput.attr('placeholder', '')
        tagsinput.css('width', '200px')
        tagsinput.css('height', '35px')
      } else if ($('.tag').length === 0) {
        tagsinput.css('width', '100%')
        tagsinput.css('height', '35px')
        tagsinput.attr('placeholder', this.placeholder)
      }
    },
    typeaheadSelected: function (val) {
      if (typeof val !== 'undefined') {
        let inputSearch = $('#input-search')
        this.queryWiki = null
        inputSearch.tagsinput('add', val)
        this.typeahead = true

        this.$refs.typeahead.activeIndex = 0
      }
    }
  },
  beforeMount () {
    this.query = this.value
  },
  mounted () {
    let inputSearch = $('#input-search')
    inputSearch.tagsinput({
      tagClass: 'btn-outline btn btn-default',
      allowDuplicates: true,
      trimValue: true
      //, cancelConfirmKeysOnEmpty: true
    })

    inputSearch.tagsinput('input').off('focusout')

    inputSearch.on('itemAdded', (event) => {
      this.parseLogicWord()
      this.query = $('#input-search').val()
      this.resizeTagsinpt()
      if (typeof this.queryWiki !== 'undefined' && this.queryWiki !== null && this.queryWiki.length !== 0) {
        this.queryWiki = null
      }
    })

    inputSearch.on('itemRemoved', (event) => {
      this.parseLogicWord()
      this.query = $('#input-search').val()
      this.resizeTagsinpt()
      this.$emit('input', this.query)
    })

    $('.bootstrap-tagsinput input').on('keypress', (event) => {
      if (event.keyCode === 13) {
        if (this.query && event.target.value === '' && this.typeahead === false) {
          this.submitSearch(null)
        }
        this.typeahead = false
      }
    })
    this.queryToTags()
    this.parseLogicWord()
    this.resizeTagsinpt()
    if (this.$user.isSe()) {
      document.title = (this.query) ? 'Lea Search - ' + this.query : 'LEA simple search'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/Simple.vue